import { usePricingModulesState } from '../../../context/contexts/PricingModuleContext';
import { Pages, Roles } from '../../../context/contexts/UserContext/permissionsTypes';
import useHasPermissions from '../../../hooks/useHasPermissions';
import { LogicalRoute, LogicalRouteImportProps } from '../../../routings/helpers/LogicalRoute';
import { AccessAnalysisCloudBlockPage } from '../screens/blockPage';
import { AccessAnalysisCloud } from '../screens/AccessAnalysisCloud';
import { LAYOUT_TABS } from '@silverfort-nodelibs/common/utils/consts';

export const AccessAnalysisCloudRouting = (props: LogicalRouteImportProps) => {
    const { isPageBlocked } = usePricingModulesState();

    const displayBlockPage = isPageBlocked(LAYOUT_TABS.ACCESS_ANALYSIS_CLOUD.ID);
    const hasOnPremPermission = useHasPermissions({ permission: Pages.ACCESS_ANALYSIS, role: Roles.VIEWER });

    const disabled = !hasOnPremPermission;

    return (
        <LogicalRoute
            blockPageComponent={AccessAnalysisCloudBlockPage}
            component={AccessAnalysisCloud}
            disabled={disabled}
            displayBlockPage={displayBlockPage}
            path={props.path}
        />
    );
};
